import {
  styled,
  Autocomplete as AutocompleteMui,
  TextField,
} from "@mui/material";

const StyledAutocomplete = styled(AutocompleteMui)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    height: "56px",
    padding: 0,
    paddingLeft: "4px",
  },
  "& .MuiOutlinedInput-input": {
    fontSize: "16px",
  },
  "& .MuiButtonBase-root": {
    color: theme.palette.icon.primary,
  },
}));

export const Autocomplete = StyledAutocomplete as typeof AutocompleteMui;

export const WhiteTextField = styled(TextField)({
  background: "white",
});
